// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1XQnF","col":"styles_col__173yv"};